<section *ngIf="!isOpened">
  <div class="row">
    <form class="needs-validation container-style" novalidate [formGroup]="formArticleTask">
      <div class="ps-2 pe-2">
        <div class="row pt-1">
          <div class="col">
            <app-custom-button [title]="'Regresar'" [icon]="'pi pi-arrow-left'" [link]="true" [label]="'Regresar'"
              [width]="'6rem'" [routerLink]="['/', url]" [severity]="null"></app-custom-button>
          </div>
          <div class="col d-flex justify-content-sm-center justify-content-end align-items-center">
            <app-navigation (buttonClick)="getButtonClick($event)"></app-navigation>
          </div>
          <div class="col mt-2 mt-sm-0 gap-1 d-flex justify-content-md-end justify-content-center">
            <app-custom-button [title]="'Eliminar'" [icon]="'pi pi-trash'" [severity]="'contrast'"
              (onClick)="delete()"></app-custom-button>

            <app-custom-button [title]="'Nuevo'" [label]="'Nuevo'" [severity]="'success'" [variant]="undefined"
              [width]="'5.5rem'" [icon]="'pi pi-plus'" (onClick)="createNewRegister()"></app-custom-button>
          </div>
          <hr class="my-1">
        </div>
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 col-12">
            <app-custom-audit-info [userNameCreate]="articleTaskContract.userNameCreate"
              [createDate]="articleTaskContract.createDate" [userNameUpdate]="articleTaskContract.userNameUpdate"
              [updateDate]="articleTaskContract.updateDate" [reserveSpace]="true"></app-custom-audit-info>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-8 col-md-7 col-sm-12 col-12 pe-md-4 pe-sm-0">
          <div class="row">
            <div class="col-lg-3 col-md-8 col-sm-4 col-6">
              <app-custom-select formControlName="branchId" [labelText]="'Sucursal'" [list]="listBranches"
                [required]="true" [recovery]="true" (onChangeSelect)="getBranch($event, true)"></app-custom-select>
            </div>
            <div class="col-lg-2 col-md-4 col-sm-2 col-6">
              <app-custom-input-number formControlName="consecutive" [labelText]="'Número'" [required]="true"
                [recovery]="true" (onChangeNumber)="changeConsecutive()"></app-custom-input-number>
            </div>
            <div class="col-lg-7 col-md-12 col-sm-6 col-12">
              <app-custom-autocomplete formControlName="articleId" [labelText]="'Artículo'" [list]="listArticles"
                [required]="true" [showExtraButton]="true" [titleExtraButton]="'Seleccionar Artículo'"
                [iconExtraButton]="'pi pi-external-link'" (onChangeSelect)="getArticle($event)"
                (clickExtraButton)="openArticleSelectionModal()"></app-custom-autocomplete>
              <app-custom-modal #articleSelection [label]="'Seleccionar'" [header]="'Selección de Equipos'"
                [children]="componentTableSelection" [inputs$]="inputsForArticlesSelection$" [output$]="output$"
                (selectedItems)="handleSelectedItem($event)" hidden></app-custom-modal>
            </div>

            <div class="col-lg-3 col-md-6 col-sm-4 col-12">
              <app-custom-datepicker formControlName="dateArticleTask" [labelText]="'Fecha'"
                [required]="true"></app-custom-datepicker>
            </div>
            <div class="col-lg-9 col-md-12 col-sm-8 col-12">
              <app-custom-input-text formControlName="description" [labelText]="'Descripción'" [required]="true"
                [maxLength]="80"></app-custom-input-text>
            </div>

            <div class="col-lg-12 col-md-12 col-sm-12 col-12">
              <app-custom-textarea class="w-100" formControlName="observation" [labelText]="'Observación'"
                [autoResize]="false" [rows]="1" [maxLength]="250">
              </app-custom-textarea>
            </div>
          </div>
        </div>
        <div id="container-right" class="col-lg-4 col-md-5 col-sm-12 col-12 ps-md-4 ps-0">
          <div class="row">
            <div class="col-lg-6 col-md-6 col-6">
              <app-custom-tag [label]="'Estado'" [severity]="severityState" [value]="stateText"></app-custom-tag>
            </div>
            <div class="col-lg-6 col-md-6 col-6 d-flex justify-content-center align-items-end mt-2">
              <app-custom-button [title]="'Finalizar Tarea'" [label]="'Finalizar Tarea'" [width]="'9rem'"
                [icon]="'pi pi-check'" [severity]="'success'" (onClick)="changeState()"
                [disabled]="disabledForm"></app-custom-button>
            </div>
            <div class="col-lg-12 col-md-12 col-sm-12 col-12 mt-1">
              <app-custom-radiobutton [listRadioButtons]="listFrequencies" [labelText]="'Periodicidad'"
                formControlName="frequency"
                [classContainer]="'d-flex justify-content-between'"></app-custom-radiobutton>
            </div>
            <div class="col-lg-6 col-md-12 col-sm-6 col-12 mt-1">
              <app-custom-select formControlName="noticeDay" [labelText]="'Días Aviso'" [list]="listNoticeDay"
                [required]="true"></app-custom-select>
            </div>
          </div>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-12 m-2 d-flex justify-content-end align-items-end">
          <app-custom-button [title]="'Guardar'" [label]="'Guardar'" [disabled]="disabledForm" [variant]="undefined"
            (onClick)="send()"></app-custom-button>
        </div>
      </div>
    </form>
  </div>
</section>
<!-- Mensaje de duplicidad ventanas abiertas -->
<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1"> highlight_off </span>
  <h6>No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
</div>